'use client';

import { useEffect, useState } from 'react';
import Script from 'next/script';
import Conditional from '@next-app/components/Conditional';
import { useSelector } from 'react-redux';
import {
  selectFeatureToggles,
  selectIsGSAUser,
} from '@next-app/lib/features/InitSelectors';

export default function GooglePayEnabled(props: any) {
  const [showGpayStatus, setShowGpayStatus] = useState(false);
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  const featureToggles = useSelector(selectFeatureToggles);
  const isGSAUser = useSelector(selectIsGSAUser);
  const { googlePayEnabled = false } = featureToggles || {};

  const isIOSDevice = () => {
    return (
      /iPad|iPhone|iPod/.test(window.navigator.userAgent) &&
      !('MSStream' in window)
    );
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const updatedShowGpayStatus =
        googlePayEnabled &&
        (window as any).google &&
        (window as any).google.payments;
      if (!updatedShowGpayStatus) {
        setShowGpayStatus(!updatedShowGpayStatus);
      } else {
        setScriptLoaded(true);
      }
      setIsIOS(isIOSDevice());
    }
  }, []);

  return (
    <>
      <Conditional
        if={showGpayStatus && !isGSAUser && googlePayEnabled && !isIOS}
      >
        <Script
          src="https://pay.google.com/gp/p/js/pay.js"
          id="googlePay"
          onLoad={() => setScriptLoaded(true)}
        />
      </Conditional>
      <Conditional if={scriptLoaded && !isGSAUser && googlePayEnabled}>
        {props.children}
      </Conditional>
    </>
  );
}
